let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fDKYj")).then(() => parcelRequire('l0I8e'));